(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-learning-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  function loadMedia(module) {
    if (!module.open) return;
    module.querySelectorAll('iframe[data-src]').forEach(frame => { frame.src = frame.dataset.src; frame.removeAttribute('data-src'); });
  }
  function revealHash() {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (!target || !target.closest('.sp-learn')) return;
    for (let node = target; node; node = node.parentElement) {
      if (node.tagName === 'DETAILS') node.open = true;
    }
    if (target.matches('.sp-module')) loadMedia(target);
    requestAnimationFrame(() => target.scrollIntoView({block: 'start'}));
  }
  function initialize() {
    document.querySelectorAll('.sp-module').forEach(module => {
      if (module.dataset.bound) return;
      module.dataset.bound = 'true';
      module.addEventListener('toggle', () => {
        loadMedia(module);
        if (!module.open) module.querySelectorAll('video').forEach(video => video.pause());
      });
    });
    const search = document.getElementById('LearningSearch');
    if (search && !search.dataset.bound) {
      search.dataset.bound = 'true';
      search.addEventListener('input', () => {
        const query = search.value.trim().toLowerCase();
        let count = 0;
        document.querySelectorAll('.sp-module,.sp-resource-item').forEach(item => {
          const match = !query || (item.dataset.search || item.textContent).toLowerCase().includes(query);
          item.hidden = !match;
          if (query && match) count++;
        });
        document.querySelectorAll('.sp-learn--part').forEach(part => {
          const matches = Array.from(part.querySelectorAll('.sp-module')).some(item => !item.hidden);
          part.hidden = !matches;
          part.querySelector('.sp-learn__part').open = Boolean(query && matches);
        });
        document.querySelectorAll('.sp-resource-group').forEach(group => {
          const matches = Array.from(group.querySelectorAll('.sp-resource-item')).some(item => !item.hidden);
          group.hidden = !matches;
          group.open = Boolean(query && matches);
        });
        const status = document.getElementById('LearningResults');
        status.textContent = query ? (count ? count + ' ' + status.dataset.found : status.dataset.empty) : '';
      });
    }
  }
  initialize();
  revealHash();
  window.addEventListener('hashchange', revealHash);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:block:select', event => {
    const module = event.target.closest('.sp-module');
    if (module) { module.closest('.sp-learn__part').open = true; module.open = true; loadMedia(module); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-news-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if(root.dataset.bound)return;
    root.dataset.bound='true';
    const grid=root.querySelector('[data-news-grid]'),archive=root.querySelector('.sp-news__archive'),status=root.querySelector('[data-news-status]'),search=root.querySelector('[data-news-search]'),sort=root.querySelector('[data-news-sort]'),more=root.querySelector('[data-news-more]'),clear=root.querySelector('[data-news-clear]');
    const topics=Array.from(root.querySelectorAll('[data-news-topic]')).map(link=>({key:link.dataset.newsTopic,label:link.dataset.topicLabel,words:link.dataset.words.toLowerCase().split(',').map(s=>s.trim()).filter(Boolean),tags:link.dataset.tags.toLowerCase().split(',').map(s=>s.trim()).filter(Boolean),handles:link.dataset.handles.split(',').map(s=>s.trim()).filter(Boolean),fallback:link.dataset.fallback==='true',link}));
    const postWord=count=>count===1?status.dataset.postSingle:status.dataset.posts;
    let posts=[],active='all',shown=9,loading=null,failed=false,request=0;
    function collect(){
      posts=Array.from(grid.querySelectorAll('[data-news-post]')).map(node=>{
        const title=node.dataset.title.toLowerCase(),tags=node.dataset.tags.toLowerCase().split('|');
        let matches=topics.filter(topic=>!topic.fallback&&(topic.handles.includes(node.dataset.handle)||topic.words.some(word=>title.includes(word))||topic.tags.some(tag=>tags.includes(tag))));
        if(!matches.length)matches=topics.filter(topic=>topic.fallback);
        node.querySelector('[data-news-post-topic]').textContent=matches.map(t=>t.label).join(' · ');
        return {node,title,date:Number(node.dataset.date),search:node.dataset.search.toLowerCase(),topics:matches.map(t=>t.key)};
      });
      topics.forEach(topic=>{const count=posts.filter(post=>post.topics.includes(topic.key)).length;topic.link.querySelector('[data-topic-count]').textContent=count+' '+postWord(count)});
    }
    function render(){
      const query=search.value.trim().toLowerCase();
      const matching=posts.filter(post=>(active==='all'||post.topics.includes(active))&&(!query||post.search.includes(query)));
      matching.sort((a,b)=>sort.value==='title'?a.title.localeCompare(b.title):sort.value==='oldest'?a.date-b.date:b.date-a.date);
      posts.forEach(post=>post.node.hidden=true);
      matching.slice(0,shown).forEach(post=>{post.node.hidden=false;grid.append(post.node)});
      status.textContent=failed?status.dataset.error:matching.length?status.dataset.showing+' '+Math.min(shown,matching.length)+' '+status.dataset.of+' '+matching.length+' '+postWord(matching.length):status.dataset.empty;
      more.hidden=shown>=matching.length&&!archive.dataset.nextUrl;
      clear.hidden=active==='all'&&!query;
      topics.forEach(topic=>topic.link.setAttribute('aria-current',String(topic.key===active)));
    }
    async function loadNext(){
      if(!archive.dataset.nextUrl)return;
      const url=new URL(archive.dataset.nextUrl,location.origin);url.searchParams.set('section_id',root.dataset.sectionId);
      const response=await fetch(url,{credentials:'same-origin'});
      if(!response.ok)throw Error('Archive request failed');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const next=doc.querySelector('[data-news-directory]');
      if(!next)throw Error('Archive section missing');
      const known=new Set(posts.map(post=>post.node.dataset.handle));
      next.querySelectorAll('[data-news-post]').forEach(node=>{if(!known.has(node.dataset.handle))grid.append(document.importNode(node,true))});
      const nextUrl=next.querySelector('.sp-news__archive').dataset.nextUrl;
      if(nextUrl===archive.dataset.nextUrl)throw Error('Archive did not advance');
      archive.dataset.nextUrl=nextUrl;collect();
    }
    async function allPages(){
      if(loading)return loading;
      loading=(async()=>{try{while(archive.dataset.nextUrl)await loadNext();failed=false;}catch{failed=true;}finally{loading=null}})();
      return loading;
    }
    async function apply(){
      const version=++request;shown=9;render();
      if(archive.dataset.nextUrl){status.textContent=status.dataset.loading;await allPages();if(version===request)render();}
    }
    topics.forEach(topic=>topic.link.addEventListener('click',event=>{event.preventDefault();active=active===topic.key?'all':topic.key;apply();archive.scrollIntoView({block:'start'});}));
    search.addEventListener('input',apply);sort.addEventListener('change',apply);
    function reset(event){event.preventDefault();active='all';search.value='';sort.value='newest';shown=9;render()}
    root.querySelector('[data-news-reset]').addEventListener('click',reset);clear.addEventListener('click',reset);
    more.addEventListener('click',async()=>{if(archive.dataset.nextUrl){more.disabled=true;await allPages();more.disabled=false;}shown+=9;render()});
    const pagination=root.querySelector('[data-news-pagination]');if(pagination)pagination.hidden=true;
    collect();render();
  }
  document.querySelectorAll('[data-news-directory]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-news-directory]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();
})();
